/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IEveFormSelect contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum fieldwidth {
    fullWidth = 'fullWidth',
    halfWidth = 'halfWidth',
    thirdWidth = 'thirdWidth',
    twoThirdWidth = 'twoThirdWidth'
}

export interface IEveFormSelectConfig extends Msdyn365.IModuleConfig {
    friendlyName?: string;
    name?: string;
    fieldwidth?: fieldwidth;
    values?: IValuesObjectData[];
    defaultIsInvalid?: boolean;
}

export interface IEveFormSelectResources {
    errorMessage: string;
}

export interface IEveFormSelectProps<T> extends Msdyn365.IModule<T> {
    resources: IEveFormSelectResources;
    config: IEveFormSelectConfig;
}

export interface IValuesObjectData {
    displayValue?: string;
    value?: string;
    isDefault?: boolean;
}
